export function highlightToHTMLString(highlight) {
  switch (highlight.label) {
    case 'superficie':
      {
        const [size, squareMeters] = highlight.value.split(' ');
        return `<strong>${size}</strong> ${squareMeters}`;
      }
    case 'piano':
      {
        if (Number.isInteger(+highlight.value)) {
          return `<strong>${highlight.value}°</strong> ${highlight.label}`;
        }
        return `Piano <strong>${highlight.value}</strong>`;
      }
    case 'anno':
      {
        return `Anno <strong>${highlight.value}</strong>`;
      }
    default:
      {
        return `<strong>${highlight.value}</strong> ${highlight.label}`;
      }
  }
}